import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Skeleton/Skeleton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Stack/Stack.js");
